import Select from 'react-select';
import React, { Component } from 'react';
import firebase from './firebase';
const moment = require('moment-timezone');

const database = firebase.database();
const divStyle = {
	margin: '35px'
};
const errorStyle = {
	color: 'red'
};
const successStyle = {
	marginTop: 30,
	color: 'gray'
};
class Form extends Component {
	state = {
		selectedOption: 'accept',
		name: '',
		message: '',
		email: '',
		error: undefined,
		nameFound: false,
		selectedQuantity: '',
		options: [ { value: 1, label: 'One' } ],
		didSelectQuantity: false,
		success: undefined
	};
	handleSelectionChange = (selectedQuantity) => {
		if (this.state.error === 'Please select a quantity!') {
			this.setState({ error: undefined });
		}
		this.setState({ selectedQuantity });
		this.setState({ didSelectQuantity: true });
	};
	handleNameChange = (event) => {
		if (this.state.error === 'Please enter your name!') {
			this.setState({ error: undefined });
		}
		this.setState({ name: event.target.value });
		this.checkQuantity(event.target.value);
	};

	handleEmailChange = (event) => {
		if (this.state.error === 'Please enter a valid email address!') {
			this.setState({ error: undefined });
		}
		this.setState({ email: event.target.value });
	};

	handleMessageChange = (event) => {
		this.setState({ message: event.target.value });
	};

	handleOptionChange = (event) => {
		this.setState({ selectedOption: event.target.value });
	};

	writeRSVP = (name, email, rsvp, message = '', quantity) => {
		firebase.database().ref('rsvp/' + moment().tz('America/Phoenix').format('MMMM Do YYYY, h:mm:ss a')).set({
			name,
			email,
			rsvp,
			message,
			quantity
		});
	};
	componentDidMount() {
		console.log(database);
	}

	validateEmail(email) {
		var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		return re.test(String(email).toLowerCase());
	}

	errorChecker = (name, email, quantity) => {
		if (!name) {
			return 'Please enter your name!';
		}
		if (!email || !this.validateEmail(email)) {
			return 'Please enter a valid email address!';
		}
		if (!quantity) {
			return 'Please select a quantity!';
		}
	};
	checkQuantity(fullName) {
		let trimmed = fullName.trim();
		let lowerCaseName = trimmed.toLowerCase();

		if (lowerCaseName in attendees) {
			let quantity = attendees[lowerCaseName];
			if (quantity === 2) {
				this.setState(() => ({
					options: options2
				}));
			} else if (quantity === 3) {
				this.setState(() => ({
					options: options3
				}));
			} else if (quantity === 4) {
				this.setState(() => ({
					options: options4
				}));
			} else {
				this.setState(() => ({
					options: options1
				}));
			}
			this.setState(() => ({
				nameFound: true
			}));
		} else {
			this.setState(() => ({
				nameFound: false,
				options: options1
			}));
		}
	}

	handleSubmit = (event) => {
		event.preventDefault();
		const error = this.errorChecker(this.state.name, this.state.email, this.state.didSelectQuantity);
		this.setState(() => ({ error }));
		if (!error) {
			this.writeRSVP(
				this.state.name,
				this.state.email,
				this.state.selectedOption,
				this.state.message,
				this.state.selectedQuantity.value
			);
			this.setState(() => ({
				name: '',
				message: '',
				email: '',
				selectedQuantity: '',
				didSelectQuantity: false,
				success: 'Thank you!'
			}));
		}
	};

	render() {
		const { selectedOption } = this.state;
		return (
			<form onSubmit={this.handleSubmit}>
				<label>
					First & Last Name
					<input type="text" value={this.state.name} onChange={this.handleNameChange} />
				</label>
				<label>
					Email Address
					<input type="text" value={this.state.email} onChange={this.handleEmailChange} />
				</label>
				<label>
					Send Us a Message
					<textarea value={this.state.message} onChange={this.handleMessageChange} />
				</label>
				<input
					type="radio"
					id="accept"
					value="accept"
					checked={this.state.selectedOption === 'accept'}
					onChange={this.handleOptionChange}
				/>
				<label htmlFor="accept">Can't Wait</label>
				<input
					type="radio"
					id="decline"
					value="decline"
					checked={this.state.selectedOption === 'decline'}
					onChange={this.handleOptionChange}
				/>
				<label htmlFor="decline">Regretfully Decline</label>
				<Select
					placeholder="How many are in your party including yourself?"
					onChange={this.handleSelectionChange}
					value={this.state.selectedQuantity}
					options={this.state.options}
					styles={customStyles}
					label="Single select"
					theme={(theme) => ({
						...theme,
						borderRadius: 0,
						colors: {
							...theme.colors,
							primary25: '#dddddd',
							primary: '#dddddd'
						}
					})}
				/>
				{this.state.didSelectQuantity === true &&
				this.state.selectedQuantity.value === 1 && (
					<h6>Note: If your name was not assigned a plus-one and you need one, please contact Carly! Her information is below.</h6>
				)}
				<div style={divStyle}>
					{this.state.error && (
						<p style={errorStyle} className="add-option-error">
							{this.state.error}
						</p>
					)}
					<input className="button special" type="submit" value="Submit" />
					{this.state.success && (
						<p style={successStyle} className="add-option-error">
							{this.state.success}
						</p>
					)}
				</div>
			</form>
		);
	}
}
const customStyles = {
	option: (provided, state) => ({
		...provided,
		color: state.isSelected ? 'black' : '#dddddd',
		padding: 10,
		backgroundColor: 'white',
		border: state.isFocused ? 0 : 0,
		boxShadow: state.isFocused ? 0 : 0,
		'&:hover': {
			border: state.isFocused ? 0 : 0
		}
	})
};
const options1 = [ { value: 1, label: 'One' } ];
const options2 = [ { value: 1, label: 'One' }, { value: 2, label: 'Two' } ];
const options3 = [ { value: 1, label: 'One' }, { value: 2, label: 'Two' }, { value: 3, label: 'Three' } ];
const options4 = [
	{ value: 1, label: 'One' },
	{ value: 2, label: 'Two' },
	{ value: 3, label: 'Three' },
	{ value: 4, label: 'Four' }
];
const attendees = {
	'daniel davidson': 2,
	'chantel davidson': 2,
	'daren davidson': 3,
	'darren davidson': 3,
	'berit davidson': 3,
	'lauri butcher': 2,
	'darren butcher': 2,
	'lauri green': 2,
	'camile davidson': 3,
	'lori davidson': 2,
	'andrew davidson': 2,
	'grandpa davidson': 2,
	'christian arias': 2,
	'makenzie arias': 2,
	'makenzie black': 2,
	'conner russell': 2,
	'jordan goodman': 2,
	'jordann goodman': 2,
	'dan humphries': 2,
	'daniel humphries': 2,
	'julia humphries': 2,
	'sid pearce': 2,
	'sidney pearce': 2,
	'mira pearce': 2,
	'carter kwon': 2,
	'scott bonar': 3,
	'stacey bonar': 3,
	'jake bonar': 2,
	'jeremy bonar': 2,
	'courtney goetz': 2,
	'sam bonar': 2,
	'samantha bonar': 2,
	'chris hicks': 2,
	'christian kicks': 2,
	'carmina garey': 2,
	'raeanne english': 2,
	'amanda bonar': 2,
	'payton mills': 2,
	'bryan watson': 2,
	'phoenix montoya': 2,
	'matt douglas': 2,
	'elley sieck': 2,
	'cecily deramo': 3,
	'mandy deramo': 3,
	'tony deramo': 3,
	'alexis roach': 2,
	'brandon bills': 2,
	'ryan lucero': 2,
	'jess lucero': 2,
	'jess antencio': 2,
	'phil haenel': 2,
	'kaitilin williams': 2,
	'kaitlin williams': 2,
	'andy markham': 2,
	'jenny markham': 2,
	'mike haenel': 2,
	'betsy haenel': 2,
	'will strong': 2,
	'william strong': 2,
	'monica strong': 2,
	'austin trefry': 1,
	'tony rowe': 2,
	'michelle rowe': 2,
	'josie capano': 4,
	'giovani capano': 4,
	'fabiola capano': 4,
	'lucrezia capano': 4,
	'benny blacklock': 2,
	'melissa george': 2,
	'melissa blacklock': 2,
	'kyl sanders': 2,
	'brandon wood': 2,
	'kellen rhodes': 2,
	'lexi gibson': 2,
	'tara werner': 2,
	'tara weirner': 2,
	'tara wierner': 2,
	'cody welch': 2,
	'mckenna brown': 2,
	'kaylah delaney': 2,
	'john blair': 2,
	'kinsey santillana': 2,
	'kevin henderson': 2,
	'jayme henderson': 2,
	'bobby price': 2,
	'robert price': 2,
	'kim lewis': 2,
	'tom lewis': 2,
	'oscar martinez': 2,
	'shayla couch': 2,
	'val baldwin': 2,
	'valarie baldwin': 2,
	'mark baldwin': 2,
	'eric katz': 2,
	'katherine katz': 2,
	'andy humpheries': 2,
	'alfredo martinez': 2
};

export default Form;
